import apiClient from '@/services/axios'

export async function post(reportId) {
  var response = await apiClient.post(`/EodReports/${reportId}`)
  if (response) {
    return response.data
  }

  throw new Error('Unable to send eod report')
}
